
import { supabase } from "@/integrations/supabase/client";

interface ElevenLabsResponse {
  success: boolean;
  error?: string;
}

export const convertTextToSpeechElevenLabs = async (text: string, voiceId?: string): Promise<ArrayBuffer> => {
  try {
    console.log('Starting ElevenLabs text-to-speech conversion...');
    
    // Fetch the ElevenLabs API key from Supabase
    const { data: secretData, error: secretError } = await supabase.functions.invoke('get-secret', {
      body: { key: 'ELEVEN_LABS_API_KEY' }
    });
    
    if (secretError || !secretData?.value) {
      console.error('Error fetching ElevenLabs API key:', secretError || 'No API key found');
      throw new Error('Failed to retrieve ElevenLabs API key');
    }
    
    const apiKey = secretData.value;
    
    // Use the provided voiceId or default to the user's preferred voice
    const voice = voiceId || 'CaJslL1xziwefCeTNzHv';
    
    console.log(`Using voice ID: ${voice}`);

    const response = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${voice}/stream`, {
      method: 'POST',
      headers: {
        'Accept': 'audio/mpeg',
        'Content-Type': 'application/json',
        'xi-api-key': apiKey,
      },
      body: JSON.stringify({
        text,
        model_id: "eleven_turbo_v2_5", // Using Turbo model
        voice_settings: {
          stability: 0.5,
          similarity_boost: 0.75,
        }
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ElevenLabs API response error:', response.status, errorText);
      throw new Error(`Failed to convert text to speech: ${response.status} ${errorText}`);
    }

    console.log('Successfully received audio from ElevenLabs');
    return await response.arrayBuffer();
  } catch (error) {
    console.error('Error in ElevenLabs text-to-speech conversion:', error);
    throw error;
  }
};
